var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "org_auth",
      attrs: {
        title: _vm.$t("tableFrom.ConfigInfo"),
        visible: _vm.authData.visible,
        wrapperClosable: false,
        size: "40%",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.authData, "visible", $event)
        },
      },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("tableFrom.ValidityPeriod"),
                name: "period",
              },
            },
            [
              _vm.activeName === "period"
                ? _c("period-pane", {
                    attrs: { authOrgData: _vm.authData },
                    on: { retRefersh: _vm.refreshTable },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("tableFrom.conInformation"),
                name: "contact",
              },
            },
            [
              _vm.activeName === "contact"
                ? _c("contact-pane", {
                    attrs: { authOrgData: _vm.authData },
                    on: { retRefersh: _vm.refreshTable },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }